import {SimpleNumberComparator} from './SimpleNumberComparator';

/**
 * Assumes heights are in mm
 */
class HeightComparator extends SimpleNumberComparator {
    constructor(closeThreshold: number) {
        super(closeThreshold);
    }
}

export {HeightComparator};
